import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function PlusRound(): React.ReactElement {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M1 11C1 16.5228 5.47715 21 11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 0.999999 11 1C5.47715 0.999999 1 5.47715 1 11ZM11 22C4.92487 22 0 17.0751 0 11C-3.37175e-07 4.92487 4.92487 -3.37175e-07 11 0C17.0751 -3.37175e-07 22 4.92487 22 11C22 17.0751 17.0751 22 11 22Z" />
      <path d="M17.4132 11.9227L11.9132 11.9227L11.9132 17.4268H10.0799L10.0799 11.9227H4.57988L4.57988 10.0894H10.0799V4.5935H11.9132L11.9132 10.0894H17.4132V11.9227Z" />
    </svg>
  );
}
